import React from "react";
import "./image-header.scss";
import PropTypes from "prop-types";

const ImageHeader = ({ imgSrc, mobileImgSrc, title }) => {
  return (
    <header
      className="image-header"
      style={{
        "--desktop-header-image": `url("${imgSrc}")`,
        "--mobile-header-image": `url("${mobileImgSrc || imgSrc}")`,
      }}
    >
      <div className="image-container d-flex flex-column justify-content-center align-items-center"></div>

      {title && (
        <div className="text-container w-100 d-flex flex-column justify-content-center align-items-center">
          <h1>{title}</h1>
        </div>
      )}
    </header>
  );
};

ImageHeader.propTypes = {
  title: PropTypes.string,
  imgSrc: PropTypes.string.isRequired,
  mobileImgSrc: PropTypes.string,
};

export default ImageHeader;